import PropTypes from 'prop-types'

import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import Chip from '@material-ui/core/Chip'
import CheckIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Cancel'
import { Alert, AlertTitle } from '@material-ui/lab'

import { useMonitorServicesQuery } from '../../services/stream-manager'

import formatAPIParams from '../../utils/formatAPIParams'

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(1),
    height: '100%',
  },
  title: {
    padding: theme.spacing(1),
  },
  chip: {
    margin: '2px 0px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  checkIcon: {
    color: theme.palette.success.main,
  },
  errorIcon: {
    color: theme.palette.error.main,
  },
}))

const ServiceHealth = ({ from, until }) => {
  const classes = useStyles()

  const monitorServiceQuery = useMonitorServicesQuery({
    params: formatAPIParams({ from, until }),
  })

  return (
    <Paper className={classes.container}>
      <Typography variant="h6" component="p" className={classes.title}>
        Service Health
      </Typography>
      {monitorServiceQuery.isLoading ? (
        <CircularProgress />
      ) : monitorServiceQuery.isSuccess ? (
        <Box sx={{ width: '100%', p: 0 }}>
          {monitorServiceQuery.data.services.map((service) => (
            <Chip
              key={service.n}
              className={classes.chip}
              label={service.n}
              icon={service.s === 'on'
                ? <CheckIcon className={classes.checkIcon} />
                : <ErrorIcon className={classes.errorIcon} />}
            />
          ))}
        </Box>
      ) : monitorServiceQuery.isError ? (
        <Alert severity="error">
          <AlertTitle>{monitorServiceQuery.error.data?.status_code}</AlertTitle>
          {monitorServiceQuery.error.data?.detail}
        </Alert>
      ) : null}
    </Paper>
  )
}



ServiceHealth.propTypes = {
  start: PropTypes.number,
  stop: PropTypes.number,
}

export default ServiceHealth
